<template>
  <!-- 外层容器作为整体背景容器 -->
  <div class="why-choose-us" v-if="hidden" :style="bgImage ? { backgroundImage: `url(${bgImage})` } : {}">
    <div class="bg-overlay"></div>
    <div class="content-wrap">
      <!-- 顶部标题区域 -->
      <div class="title-box">
        <!-- 上方小字 -->
        <span class="sub-title">{{ subTitle }}</span>
        <!-- 主标题 -->
        <h1 class="banner-title">{{ pageTitle }}</h1>
        <!-- 下方装饰线 -->
        <div class="line-wrapper">
          <div class="moving-line"></div>
        </div>
      </div>

      <!-- 卡片列表 -->
      <div class="card-container" v-if="cardList.length">
        <div class="card-item" v-for="item in cardList" :key="item.num">
          <div class="icon-box">
            <img :src="item.image" alt="icon" />
          </div>
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <!-- 最底部的平滑移动装饰线 -->
    <div class="bottom-line">
      <div class="stripes line1"></div>
      <div class="stripes line2"></div>
    </div>
  </div>
</template>

<script>
import { leftLikeDict } from "@/api/system";
import { findDictHidden} from '../../utils';
import Constant from "@/utils/Constant";

export default {
  data() {
    return {
      pageTitle: "",
      bgImage: "",
      cardList: [],
      // 截图里的固定小字
      subTitle: "COMPANY CULTURE",
      hidden: true
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const res = await leftLikeDict(Constant.FIVENAV_ONE4);

        let rootData = [];
        if (res && Array.isArray(res.data)) {
          rootData = res.data;
        } else if (res && res.data && Array.isArray(res.data.data)) {
          rootData = res.data.data;
        }

        this.hidden = findDictHidden(Constant.FIVENAV_ONE4, res.data.data)

        if (!Array.isArray(rootData) || rootData.length === 0) {
          console.log("未获取到有效数据");
          return;
        }

        // 改用 for 循环替代 find，彻底解决报错
        let titleItem = {};
        let bgItem = {};
        for (let i = 0; i < rootData.length; i++) {
          const item = rootData[i];
          if (item.dictKey === "fivenav_one4Title") {
            titleItem = item;
          }
          if (item.dictKey === "fivenav_one4Background") {
            bgItem = item;
          }
        }

        this.pageTitle = titleItem.dictValue || "";
        this.bgImage = bgItem.dictValue || "";

        const children = Array.isArray(titleItem.children) ? titleItem.children : [];
        const cards = [];

        // 遍历解析卡片 1~6
        for (let n = 1; n <= 6; n++) {
          let titleObj = null;
          let imgObj = null;
          let sub1Obj = null;
          let sub2Obj = null;

          // 子项也用 for 循环
          for (let j = 0; j < children.length; j++) {
            const c = children[j];
            if (c.dictKey === `fivenav_one4Content${n}Title`) {
              titleObj = c;
            }
            if (c.dictKey === `fivenav_one4Content${n}Image`) {
              imgObj = c;
            }
            if (c.dictKey === `fivenav_one4Content${n}SubTitle1`) {
              sub1Obj = c;
            }
            if (c.dictKey === `fivenav_one4Content${n}SubTitle2`) {
              sub2Obj = c;
            }
          }

          if (!titleObj) continue;

          cards.push({
            num: n,
            title: titleObj.dictValue || "",
            image: imgObj ? imgObj.dictValue : "",
            desc: ((sub1Obj ? sub1Obj.dictValue : "") + " " + (sub2Obj ? sub2Obj.dictValue : "")).trim()
          });
        }

        this.cardList = cards;
      } catch (err) {
        console.error("数据加载异常:", err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.why-choose-us {
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;

  .bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }

  .content-wrap {
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 120px 0 60px; /* 顶部距离保持不变 */
  }

  .bottom-line {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 40px; /* 容纳两条20px高的线 */
    overflow: hidden;
    background: #000;

    .stripes {
      position: absolute;
      left: 0;
      width: 200%;
      height: 20px; /* 单条线高 20px */
      background: repeating-linear-gradient(
              90deg,
              #880f53 0,
              #880f53 20px,
              transparent 20px,
              transparent 40px
      );
      animation: moveStripes 35s linear infinite;
    }

    /* 上线：正常位置 */
    .line1 {
      top: 0;
    }

    /* 下线：水平错位 20px，和上线形成你图里的“台阶”效果 */
    .line2 {
      top: 20px;
      left: 20px;
      opacity: 0.8;
    }
  }
}
.title-box {
  text-align: center;
  margin-bottom: 80px;

  .sub-title {
    display: inline-block;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    padding: 8px 20px;
    margin-bottom: 1px; /* 缩小小字和主标题间距 */
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  .banner-title {
    color: #fff;
    font-size: 60px;
    font-weight: bold;
    margin: 0 0 12px; /* 缩小主标题和装饰线间距 */
    text-transform: capitalize;
  }

  /* 优化装饰线样式 + 左右滑动动画 */
  .line-wrapper {
    width: 160px;
    height: 10px;
    margin: 0 auto;
    overflow: hidden;
    background: rgb(255, 255, 255);
    border-radius: 3px;

    .moving-line {
      width: 40%;
      height: 100%;
      background: #880f53;
      border-radius: 3px;
      animation: moveLine 1.5s infinite ease-in-out alternate;
    }
  }
}

/* 左右滑动动画 */
@keyframes moveLine {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(150%);
  }
}

/* 底部装饰线移动动画 */
@keyframes moveStripes {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.card-container {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.card-item {
  background: #fff;
  border-radius: 20px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

  .icon-box {
    width: 118px;
    height: 118px;
    background: #880f53;
    border: 7px solid #000;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    /* 开启3D空间 */
    transform-style: preserve-3d;
    perspective: 1000px;
    transition: transform 0.6s ease;

    img {
      width: 60%;
      height: 60%;
      object-fit: contain;
      transition: transform 0.6s ease;
    }
  }

  /* 鼠标移入卡片图片区域，触发翻转 */
  &:hover .icon-box {
    transform: rotateY(180deg);
  }

  .card-title {
    font-size: 28px;
    font-weight: bold;
    font-family: 'Roboto_Bold', sans-serif;
    margin-bottom: 15px;
    color: #0c0c0c;
  }

  .card-desc {
    font-size: 20px;
    color: #2c2c2c;
    line-height: 1.6;
    font-family: 'Roboto', sans-serif;
  }
}

@media (max-width: 768px) {
  .content-wrap {
    padding: 80px 0 40px;
  }
  .card-container {
    grid-template-columns: 1fr;
    gap: 20px;
    width: 94%;
  }
  .title-box .banner-title {
    font-size: 36px; /* 移动端大字 */
  }
  .title-box .sub-title {
    font-size: 16px; /* 移动端大字 */
  }
  /* 顶部装饰线 生效适配 */
  :deep(.line-wrapper) {
    width: 130px !important;
    height: 5px !important;
  }

  .why-choose-us {
    min-height: auto;
  }
  .card-item {
    padding: 32px 20px;
  }
  .card-item .icon-box {
    width: 106px;
    height: 106px;
    border-width: 6px;
  }
  .card-item .card-title {
    font-size: 24px;
  }
  .card-item .card-desc {
    font-size: 16px;
  }
}
</style>